// If you are adding a term to the Action glossary,
// please add a member of the Data team to your PR

export const Action = {
  accepted: 'accepted',
  added: 'added',
  advanced: 'advanced',
  allowed: 'allowed',
  archived: 'archived',
  attached: 'attached',
  autoEnabled: 'autoEnabled',
  blurred: 'blurred',
  cancelled: 'cancelled',
  changed: 'changed',
  checked: 'checked',
  cleared: 'cleared',
  clicked: 'clicked',
  closed: 'closed',
  collapsed: 'collapsed',
  commented: 'commented',
  completed: 'completed',
  confirmed: 'confirmed',
  converted: 'converted',
  copied: 'copied',
  crashed: 'crashed',
  created: 'created',
  deleted: 'deleted',
  denied: 'denied',
  disabled: 'disabled',
  dismissed: 'dismissed',
  downloaded: 'downloaded',
  edited: 'edited',
  enabled: 'enabled',
  entered: 'entered',
  errored: 'errored',
  evaluated: 'evaluated',
  executed: 'executed',
  expanded: 'expanded',
  exposed: 'exposed',
  failed: 'failed',
  fetched: 'fetched',
  filtered: 'filtered',
  finished: 'finished',
  focused: 'focused',
  hid: 'hid',
  highlighted: 'highlighted',
  hovered: 'hovered',
  initialized: 'initialized',
  inserted: 'inserted',
  installed: 'installed',
  invited: 'invited',
  invoked: 'invoked',
  joined: 'joined',
  left: 'left',
  loaded: 'loaded',
  loggedIn: 'loggedIn',
  loggedOut: 'loggedOut',
  mentioned: 'mentioned',
  mounted: 'mounted',
  moved: 'moved',
  navigated: 'navigated',
  opened: 'opened',
  optedIn: 'optedIn',
  optedOut: 'optedOut',
  ordered: 'ordered',
  pressed: 'pressed',
  processed: 'processed',
  readyForUser: 'readyForUser',
  received: 'received',
  refreshed: 'refreshed',
  removed: 'removed',
  rendered: 'rendered',
  renewed: 'renewed',
  reopened: 'reopened',
  reordered: 'reordered',
  requested: 'requested',
  retrieved: 'retrieved',
  saved: 'saved',
  searched: 'searched',
  selected: 'selected',
  sent: 'sent',
  set: 'set',
  shared: 'shared',
  shown: 'shown',
  skipped: 'skipped',
  sorted: 'sorted',
  starred: 'starred',
  started: 'started',
  stopped: 'stopped',
  submitted: 'submitted',
  subscribed: 'subscribed', // Use for watching card, list, board
  succeeded: 'succeeded',
  suggested: 'suggested',
  timedOut: 'timedOut',
  toggled: 'toggled',
  transitioned: 'transitioned',
  triggered: 'triggered',
  unchecked: 'unchecked',
  unstarred: 'unstarred',
  unsubscribed: 'unsubscribed', // Use for unwatching card, list, board
  updated: 'updated',
  upgraded: 'upgraded',
  uploaded: 'uploaded',
  verified: 'verified',
  viewed: 'viewed',
} as const;

export type ActionType = typeof Action[keyof typeof Action];

export const isValidAction = (a: ActionType) => {
  const validSources = Object.values(Action);
  return validSources.includes(a);
};
